import IConfirmBookingRequest from '../interfaces/IConfirmBookingRequest';
import IOutstandingBalance from '../interfaces/IOutstandingBalance';
import errorHelpers from '../helpers/errors';
import Logging from './logging';

interface IBalanceErrorBody {
    errorType?: string;
}

class BalancePayments {
    static GetOutstandingBalance = async (bookingRef: string): Promise<IOutstandingBalance> => {
        const response = await fetch(`bookings/${bookingRef}/balance`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const body = (await response.json().catch(() => undefined)) as IBalanceErrorBody | undefined;
            const error = new Error(response.url) as Error & { errorType?: string };
            error.name = 'Status code: ' + response.status.toString();
            error.errorType = body?.errorType;
            Logging.LogError(error);
            throw error;
        }

        return (await response.json()) as IOutstandingBalance;
    };

    static ConfirmBalancePayment = (
        siteId: number,
        bookingRef: string,
        request: IConfirmBookingRequest
    ): Promise<string> => {
        return fetch(`bookings/${siteId}/${bookingRef}/confirm`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        })
            .then((response) => errorHelpers.handleErrors(response))
            .then((response) => response.text() as Promise<string>);
    };
}

export default BalancePayments;
